import { AlertWarning } from "../widgets/alert";

interface PropTypes {
  message: string;
}

export const NotFound = ({ message }: PropTypes) => (
  <AlertWarning
    message={_("{MESSAGE} not found. Please remove it.").replace(
      "{MESSAGE}",
      message,
    )}
  />
);

NotFound.displayName = "NotFound";
